angular.module('tgaAdmin').controller('HubAwardsController', [
  '$scope',
  '$state',
  '$window',
  'domainService',
  'envService',
  function ($scope, $state, $window, domainService, envService) {
    $scope.showBack = $state.current.data.back;

    $scope.data = {
      hubId: $state.params.hub_id || null,
      environment: envService.get(),
    };

    $scope.viewmodel = {
      hub_id: $state.params.hub_id,
    };

    $scope.initialize = function () {
      if ($scope.data.environment !== 'development') {
        // eslint-disable-next-line max-len
        $window.location.href = `${$window.location.protocol}//${domainService.domain}.${domainService.base}/admin/v2/hub/${$scope.data.hubId}/awards`;
      } else {
        $window.location.href = `${$window.location.protocol}//${$window.location.host}/v2/hub/${$scope.data.hubId}/awards`;
      }
    };

    $scope.actions = {};

    $scope.initialize();
  },
]);
